<template>
  <component :applyTypeName="this.applyTypeName"  :is="operationView" :_dataId.sync="dataId" :type="type" @reloadWf="reloadWf" :parent-target="_self" @editViewDataUpdate="editViewDataUpdate"  @reload="$reloadHandle" style="overflow-y: none!important;"></component>
</template>
<script>
import request from "@/router/axios";
import wfView from "../index";
  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['multi','wfData', ],
    components: {
      wfView,
    },
    computed: {
      operationView(){
        return () => import("../index.vue")
      }
    },
    created() {
	    console.log(this.$route);
    },
    data() {
      return {
        isShow:false,

        show3: false,
        dataId: '',
        dataType:'',
        dataNo:'',
        type:"wf",
        applyTypeName: "社会化服务商退换货物流运输费申请",
        form2: {
          desc: '',
          name: "",
        },
        showOrderPop: false,

        drawer: true,
        formData: {},
        srcList: [],
        returnData:{},
        wfExtend:{}
      }
    },

    mounted() {
    },
    methods: {
      reloadWf(){
        this.$emit('closeWfDialog',false)
      },
      editViewDataUpdate(){
        console.log(11,"关闭通过");
        this.$emit('closeWfDialog',false)
      },
      // 工单弹窗选中
      orderCommit(row) {
        this.formData.orderNo = row.orderNo
        this.formData.orderId = row.orderId
      },
      shut() {
        // this.showOrderPop=true
      },
      cancelForm() {
        this.drawer = false;
        clearTimeout(this.timer);
        this.$emit('closeWfDialog', false)
      },
      handleClose() {
        this.drawer = false;
        this.$emit('closeWfDialog', false)
      },
      getWfExtendMsg(){
        this.$http({
          url: "/act/wf/getWfExtendMsg",
          method: 'post',
          data: {
            processId: this.processId
          }
        }).then(res => {
          this.wfExtend = res.data.data;
          this.wfData.wfClass = this.wfExtend.wfClass;
          this.wfData.wfMethod = this.wfExtend.wfMethod;
          this.wfData.wfView = this.wfExtend.wfView;
          this.wfData.wfReject = this.wfExtend.wfReject;
          this.wfData.wfStop = this.wfExtend.wfStop
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
.details2{

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
//   3个标签
.information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }
//   每个分支
.d-item {
  border: 1px solid #ededed;
  padding-bottom: 5px;

  .title b {
    display: inline-block;
    line-height: 20px;
    font-size: 13px;
    font-weight: 600;
    margin-right: 84px;
    vertical-align: middle;
    color: rgb(42, 100, 148);
    position: relative;
    z-index: 2;
    background: rgba(42, 100, 148, 0.16);
    margin-left: 0px;
    margin-bottom: 8px;
    padding-left: 12px;
    padding-right: 14px;
    border-radius: 0px 28px 28px 0px;
}
.table-detail tr {
    margin-bottom: 10px;
    display: block;
th {
    font-weight: 400;
    text-align: right;
    width: 7vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 5px 0 4px;
    color: rgba(86, 86, 86, 0.96);
}
td {
    font-weight: 400;
    // text-align: right;
    width: 10vw !important;
    font-size: 12px;
    position: relative;
    padding: 0 0px 0 4px;
    color: rgba(0, 0, 0,);
}
}}

::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space:nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }
  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }
 ::v-deep  .el-step__title {
    font-size: 13px!important;
    line-height: 38px;
}
}
</style>
